import {useEffect, useRef} from 'react';
import affiliateAnalytics from '@xo-union/affiliate-marketing-analytics';

const useIdentifyMember = customer => {
  const consentedCategories = useRef([]);

  const checkForReload = categories => {
    const hasChangedConsentedCategories =
      JSON.stringify(categories) !==
      JSON.stringify(consentedCategories.current);

    if (!hasChangedConsentedCategories) return;

    window.location.reload();
  };

  const identifyCustomer = () => {
    if (!customer?.id) return;

    affiliateAnalytics.identify({
      customerId: customer.id,
      customerEmail: customer.email,
    });
  };

  useEffect(() => {
    if (!window.UnionConsentManagement) {
      identifyCustomer();

      return undefined;
    }

    window.UnionConsentManagement.registerService({
      name: 'Segment',
      setup(consent) {
        /**
         * handles setting the initial state of the consented categories
         */
        if (!consentedCategories.current.length) {
          consentedCategories.current = consent.categories;
        }

        if (!consent.consentedToTargeting && !consent.consentedToAnalytics) {
          checkForReload(consent.categories);

          return undefined;
        }

        identifyCustomer();

        checkForReload(consent.categories);

        return undefined;
      },
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.id]);
};

export default useIdentifyMember;
